import { createFileRoute, Outlet } from '@tanstack/react-router'
import { serviceJobPageSearchSchema } from '../../../../../features/service/search'

/**
 * The job and its customer documents (the estimate). The job page's search and crumb stay on this
 * route, so `/service/jobs/$jobId` behaves as before and the estimate sits under the job's crumb.
 */
export const Route = createFileRoute('/_app/service/jobs/$jobId')({
  staticData: { crumb: 'serviceJob' },
  validateSearch: serviceJobPageSearchSchema,
  component: Outlet,
})
